import global from "@/locales/nl-BE/global";
import error403 from "@/locales/nl-BE/errors/403";
import error404 from "@/locales/nl-BE/errors/404";
import error500 from "@/locales/nl-BE/errors/500";
import error503 from "@/locales/nl-BE/errors/503";
import error504 from "@/locales/nl-BE/errors/504";
import maintenance from "@/locales/nl-BE/auth/maintenance";
import toast from "@/locales/nl-BE/toast/toast";
import login from "@/locales/nl-BE/auth/login";
import onboarding from "@/locales/nl-BE/auth/onboarding";
import loginPageSteps from "@/locales/nl-BE/loginPageSteps";
import dashboard from "@/locales/nl-BE/dashboard/dashboard";
import account from "@/locales/nl-BE/account/account";
import mailbox from "@/locales/nl-BE/account/mailbox";
import bankstatement from "@/locales/nl-BE/account/bankstatement";
import myApps from "@/locales/nl-BE/my-apps/myApps";
import about from "@/locales/nl-BE/about/about";
import contactService from "@/locales/nl-BE/about/contactService";
import salesPromotions from "@/locales/nl-BE/sales/promotions";
import brochures from "@/locales/nl-BE/sales/brochures";
import shop from "@/locales/nl-BE/shop/data";
import priceList from "@/locales/nl-BE/shop/priceList";
import staff from "@/locales/nl-BE/dashboard/staff";
import promotions from "@/locales/nl-BE/promotions";
import points from "@/locales/nl-BE/points";
import trainings from "@/locales/nl-BE/trainings/trainings";
import vouchers from "@/locales/nl-BE/vouchers/vouchers";
import generateReport from "@/locales/nl-BE/generate-report/generateReport";
import widgets from "@/locales/nl-BE/widgets/widgets";
import wholesaler from "@/locales/nl-BE/wholesaler/wholesaler";
import media from "@/locales/nl-BE/media/index";
import product from "@/locales/nl-BE/product/index";
import message from "@/locales/nl-BE/message/index";
import commitmentLetter from "@/locales/nl-BE/account/commitmentLetter";
import multiplicator from "@/locales/nl-BE/multiplicator";
import consents from "@/locales/nl-BE/consents/consents";
import investment from "@/locales/nl-BE/investment/data";
import kickback from "@/locales/nl-BE/kickback";

//prettier-ignore
const messages = {
  loginPageSteps: loginPageSteps.messages,
  global: global.messages,
  error403: error403.messages,
  error404: error404.messages,
  error500: error500.messages,
  error503: error503.messages,
  error504: error504.messages,
  maintenance: maintenance.messages,
  toast: toast.messages,
  login: login.messages,
  onboarding: onboarding.messages,
  dashboard: dashboard.messages,
  multiplicator: multiplicator.messages,
  account: account.messages,
  mailbox: mailbox.messages,
  myApps: myApps.messages,
  bankstatement: bankstatement.messages,
  about: about.messages,
  contactService: contactService.messages,
  salesPromotions: salesPromotions.messages,
  shop: shop.messages,
  staff: staff.messages,
  promotions: promotions.messages,
  points: points.messages,
  brochures: brochures.messages,
  trainings: trainings.messages,
  vouchers: vouchers.messages,
  generateReport: generateReport.messages,
  widgets: widgets.messages,
  wholesaler: wholesaler.messages,
  media: media.messages,
  priceList: priceList.messages,
  productInfo: product.messages,
  message: message.messages,
  commitmentLetter: commitmentLetter.messages,
  consents: consents.messages,
  investment: investment.messages,
  kickback: kickback.messages,
  kickbackInfo: { withdraw: "Voor het uitbetalen van de bonus" },
  productBrochures: {
    BDriveTitle: "Productafbeeldingen",
    BDriveLinkText: "Link naar het PRODUCTAFBEELDINGEN-portaal",
  },
}

export default {
  locale: "nl-BE",
  messages,
};
